import api from "../../config/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ROUTES } from "../../config/apiRoutes";
import { updateSentMessage } from "./messagesSlice";

/**✅ waChats Thunk */
export const getChatContacts = createAsyncThunk(
    "messages/getChatContacts",
    async (payload = {}, { rejectWithValue, getState }) => {

        const state = getState();
        const user = state.authentication?.user;

        try {
            const response = await api.post(API_ROUTES.WA_MESSAGE_CONTACTS, {
                employee_id: user?.user_id,
                page: payload.page || 1,
                filterType: payload.filterType || 0,
                limit: payload.limit || 50,
                branch_department_ids: payload.branch_department_ids || [],
                tag_ids: payload.tag_ids || [],
                qr_code_ids: payload.qr_code_ids || [],
                organisation_ids: payload.organisation_ids || [],
                search: payload.search || ""
            });

            const { statusCode, data, message } = response.data;

            if (statusCode === 200) {
                return { data: data.messages, pagination: data.pagination };
            }

            return rejectWithValue(message || "Chats failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Chats failed"
            );
        }
    }
);


export const getWaChatsThunk = createAsyncThunk(
    "messages/getWaChatsThunk",
    async ({ credentials }, { rejectWithValue, getState }) => {
        const state = getState();
        if (state.messages?.selectedUser === null) return "";
        const selectedUser = state.messages?.selectedUser;
        const payload = {
            ...credentials,
        };

        try {
            const response = await api.post(API_ROUTES.WA_CHATS, payload);
            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {

                const updatedData = data.map((chat) => ({
                    ...chat,
                    wa_contact_id: selectedUser,
                }));

                return { updatedData };
            }

            return rejectWithValue(message || "Chats failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Chats failed"
            );
        }
    }
);


// mark messages as read
export const updateMessagesCountThunk = createAsyncThunk(
    "messages/updateMessagesCount",
    async (_, { rejectWithValue, getState }) => {
        const state = getState();
        const wa_contact_id = state.messages?.selectedUser;

        if (!wa_contact_id) return rejectWithValue("No contact selected");

        try {
            const response = await api.post(API_ROUTES.UPDARE_MESSAGE_COUNT, {
                "wa_contact_id": wa_contact_id,
            });

            const { statusCode } = response.data;

            if (statusCode === 200) {
                return { wa_contact_id };
            }

            return rejectWithValue("Failed to update message count");
        } catch (err) {
            return rejectWithValue(err.response?.data || "Error updating message count");
        }
    }
);



// send a new message (optimistic update)
export const submitNewMessageThunk = createAsyncThunk(
    "messages/submitNewMessage",
    async (formData, { dispatch, rejectWithValue, getState }) => {

        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...formData,
            employee_id: user?.user_id,
        };

        try {
            const tempMessage = {
                id: `temp-${Date.now()}`,
                content: payload.user_message,
                media_type: payload.type,
                time: new Date().toLocaleTimeString("en-GB", {
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: false,
                }),
                status: "sending",
            };

            dispatch(updateSentMessage(tempMessage));

            await api.post(API_ROUTES.SEND_MESSAGE, payload);
            return payload;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Error sending message");
        }
    }
);

export const sendWaConvoTemplateThunk = createAsyncThunk(
    "messages/sendWaConvoTemplateThunk",
    async ({ credentials }, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            employee_id: user?.user_id,
        };

        try {
            const response = await api.post(API_ROUTES.SEND_TEMPLATE, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 200) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "Template failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Template failed"
            );
        }
    }
);


export const getContactFilters = createAsyncThunk(
    "messages/getContactFilters",
    async (payload = {}, { rejectWithValue, getState }) => {

        const state = getState();
        const user = state.authentication?.user;


        // 👈 Skip API if data already in state
        if (payload.type !== "getFilters") {
            if (state.messages?.waContactUserFilterArr?.length > 0) {
                return state.messages.waContactUserFilterArr;
            }
        }

        try {
            const response = await api.post(API_ROUTES.CONTACT_FILTERS, { employee_id: user?.user_id, });
            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Chats failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Chats failed"
            );
        }
    }
);